import { style } from "@vanilla-extract/css";
import {
  cellStyles,
  columnStyles,
  tableStyles,
} from "plos/src/components/Table/tables.css";
import { breakpoints, vars } from "plos/src/styles";

export const cupTypeStyles = style({
  display: "grid",
  gap: vars.space.xs,
});

export const cupTypeTableStyles = style([
  tableStyles,
  {
    tableLayout: "fixed",
  },
]);

export const cupColStyles = style([
  columnStyles,
  {
    width: "36%",
    textAlign: "start",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "70%",
      },
    },
  },
]);

export const generalColStyles = style([
  columnStyles,
  {
    width: "29%",
    textAlign: "end",
    "@media": {
      [`screen and (min-width: ${breakpoints[4]})`]: {
        width: "12%",
      },
    },
  },
]);

export const generalCellStyles = style([
  cellStyles,
  {
    textAlign: "end",
  },
]);
